// Copyright 2025, Imprivata, Inc.  All rights reserved.

import { LegalFileUpload } from '@components/legalFileUpload/LegalFileUpload';
import type { ComponentType } from 'react';
import { useTranslation } from 'react-i18next';
import Appearance from '../appearance/Appearance';
import Applications from '../applications/Applications';
import Workflows from '../eamc/Workflows';
import Endpoints from '../endpoints/Endpoints';
import IdentityUsers from '../identityUsers/IdentityUsers';
import AipIntegration from '../integrations/AipIntegration';
import EamIntegration from '../integrations/EamIntegration';
import IdvConnections from '../integrations/IdvConnections';
import SamlIdp from '../integrations/SamlIdp';
import VpamIntegration from '../integrations/VpamIntegration';
import PasswordPolicy from '../passwordPolicy/PasswordPolicy';
import Reports from '../reports/Reports';
import Security from '../security/Security';
import Users from '../users/Users';
import Overview from './Overview';
import type { PageItem, SettingsTab } from './SettingsTabs';
import './Settings.less';

// Bound here rather than in the registry: pages import the registry, so the
// registry importing pages would be a cycle.
const PAGE_COMPONENTS: Record<SettingsTab, ComponentType> = {
  overview: Overview,
  users: Users,
  'identity-users': IdentityUsers,
  applications: Applications,
  'saml-idp': SamlIdp,
  'eam-integration': EamIntegration,
  'vpam-integration': VpamIntegration,
  'aip-integration': AipIntegration,
  'oidc-integrations': IdvConnections,
  security: Security,
  'password-policy': PasswordPolicy,
  'branding-and-labels': Appearance,
  'biometric-consent': LegalFileUpload,
  'hub-reports': Reports,
  endpoints: Endpoints,
  workflows: Workflows,
  reports: Reports,
};

type SettingsProps = { item: PageItem };

const Settings = ({ item }: SettingsProps) => {
  const { t } = useTranslation();

  const Page = PAGE_COMPONENTS[item.key];

  return (
    <div className="settings-container">
      {item.hideTitle ? (
        <h1 className="sr-only">{t(item.titleKey)}</h1>
      ) : (
        <div className="settings-header-bar">
          <div className="settings-header">
            <div className="settings-header-left">
              <h1>{t(item.titleKey)}</h1>
            </div>
          </div>
        </div>
      )}

      <div className="settings-content">
        <Page key={item.key} />
      </div>
    </div>
  );
};

export default Settings;
